import script from "./SwitzerlandGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./SwitzerlandGuide.vue?vue&type=script&lang=ts&setup=true"

import "./SwitzerlandGuide.vue?vue&type=style&index=0&id=6def8c24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6def8c24"]])

export default __exports__